import { render, staticRenderFns } from "./ExportAsCsv.vue?vue&type=template&id=e4c4b6ac&scoped=true"
import script from "./ExportAsCsv.vue?vue&type=script&lang=js"
export * from "./ExportAsCsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c4b6ac",
  null
  
)

export default component.exports